import { IconButton, Stack, Tooltip } from '@chronosphereio/chrono-ui';
import { MagnifyMinusOutline as MinusCircleOutline, MagnifyPlusOutline as PlusCircleOutline } from 'mdi-material-ui';
import { Labels } from '@/core';
import { GlobalFilter } from '@/plugin-system';
import { labelsToFilters } from '@/plugin-system/utils/label-filters';

const ADD_LABEL_TEXT = 'Add label to filters';
const REMOVE_LABEL_TEXT = 'Remove label from filters';

export function LabelFilterButtons(props: { labels: Labels; onAddFilters: (filters: GlobalFilter[]) => void }) {
  const { labels, onAddFilters } = props;
  const getFilters = (matcher: '=' | '!=') => {
    return labelsToFilters(labels, { matcher });
  };

  const includeFilters = getFilters('=');
  const excludeFilters = getFilters('!=');

  if (includeFilters.length === 0) {
    return null;
  }

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Tooltip Content={ADD_LABEL_TEXT} enterDelay={500}>
        <IconButton
          aria-label={ADD_LABEL_TEXT}
          sx={{
            // Avoid the icon height impacting the layout beyond the lineHeight of the text. This avoids the cell
            // shifting a little when the cell is expanded and needs to rely on padding to maintain the layout of the
            // content.
            maxHeight: (t) => t.typography.body2.lineHeight,
          }}
          size="small"
          onClick={(e) => {
            // Stop propagation, so clicking these buttons doesn't accidentally trigger row click behavior in
            // tables.
            e.stopPropagation();
            onAddFilters(includeFilters);
          }}
        >
          <PlusCircleOutline />
        </IconButton>
      </Tooltip>
      <Tooltip Content={REMOVE_LABEL_TEXT} enterDelay={500}>
        <IconButton
          aria-label={REMOVE_LABEL_TEXT}
          size="small"
          sx={{
            // Avoid the icon height impacting the layout beyond the lineHeight of the text. This avoids the cell
            // shifting a little when the cell is expanded and needs to rely on padding to maintain the layout of the
            // content.
            maxHeight: (t) => t.typography.body2.lineHeight,
          }}
          onClick={(e) => {
            // Stop propagation, so clicking these buttons doesn't accidentally trigger row click behavior in
            // tables.
            e.stopPropagation();

            onAddFilters(excludeFilters);
          }}
        >
          <MinusCircleOutline />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
